<template>
  <div class="template-layout layers">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">

        <div class="top-taller"></div>

        <div class="hero-row">

          <div class="hero" @click="goVideo">
            <img class="hero-img" src="./img/About-video.jpg" />
            <div class="hero-overlay"></div>
            <img class="hero-play" src="./img/play.svg" />
          </div>

        </div>

        <div class="col" ref="radianceis-section">
          <div class="row about-radiance-is">
            <span v-if="SC.U === ENG">ABOUT RADIANCE IS</span>
            <span v-if="SC.U === CHI">關於Radiance Is</span>
          </div>

          <div class="row about-radiance-is-desc-row">
            <div class="about-radiance-is-desc">
              <span v-if="SC.U === CHI">
                Clé de Peau Beauté與願望成真基金攜手推出 「Radiance Is」慈善活動，藉此鼓勵大家傳承閃耀， 為願望童帶來更多關愛和希望。
                <br />
                <br />
                獲獎導演黃飛鵬及監製麥曦茵為其中五位「閃耀大使」袁詠儀、李玟、周麗淇、林恬兒和願望童及義工卓妍拍攝短片，分享她們的「閃耀故事」，將光芒傳承他人。同時亦邀請時尚插畫家Mickco Chan 為活動製作動畫短片，以輕鬆手法點亮更多璀璨奇蹟。
                <br />
                <br />
                在4月4日至29日期間，Clé de Peau Beauté誠邀您一同凝聚5,000個閃耀時刻，並於活動後捐出港幣$150,000予願望成真基金，傳承閃耀，為願望童帶來更多關愛和希望。
              </span>
              <span v-if="SC.U === ENG">
                <!-- Clé de Peau Beauté and Make-A-Wish Hong Kong developed the “Radiance Is” digital campaign and invited 5 of the 20 illuminating stars including Anita Yuen, Coco Lee, Niki Chow, Emily Lam Ho and a Make-A-Wish Hong Kong Wish Alum and Volunteer Cheuk Yin, to share their radiant stories in videos which are co-directed by award-winning directors, Mr. Wong Fei Pang and produced by Ms. Heiward Mak. <span class="break767"><br/><br/></span> <span class="break375"><br/><br/></span> Clé de Peau Beauté has also invited the Hong Kong illustrator, Mickco Chan to create a “Radiance” video, to share the message of “Unlock the Power of Your Radiance”. -->
                Clé de Peau Beauté and Make-A-Wish Hong Kong developed the “Radiance Is” digital campaign and invited 5 of the 20 illuminating stars including Anita Yuen, Coco Lee, Niki Chow, Emily Lam Ho and a Make-A-Wish Hong Kong Wish Alum and Volunteer Cheuk Yin, to share their radiant stories in videos which are directed by award-winning director, Mr. Wong Fei Pang and produced by Ms. Heiward Mak. <span class="break767"><br/><br/></span> <span class="break375"><br/><br/></span> Clé de Peau Beauté has also invited the Hong Kong illustrator, Mickco Chan to create a “Radiance” video, to share the message of “Unlock the Power of Your Radiance”.
                <br />
                <br />
                During April 4 -29, Clé de Peau Beauté cordially invites you to raise 5,000 radiance, and will donate HK$150,000 to Make-A-Wish Hong Kong, to extend its radiance and grant more life-changing wishes to children in need.
              </span>
            </div>
          </div>
        </div>

        <div class="row line-row">
          <div class="line"></div>
        </div>

          <!-- <div class="row line-row">
            <div class="line"></div>
          </div> -->

          <!-- <div class="row abt-maw-row">
            <div class="abt-maw">
              ABOUT MAKE-A-WISH
            </div>
          </div>

          <div class="row abt-maw-desc-row">
            <div class="abt-maw-desc">
              Make-A-Wish Hong Kong is the world’s largest wish-granting organization. Since 1998, the Hong Kong office has granted over 1,800 wishes. A wish-come-true experience transforms lives and empowers children to fight harder against critical illnesses! These wishes do not only help these children – they also have far-reaching, positive impacts on their families and communities. As Make-A-Wish Hong Kong is celebrating our 20th Anniversary in 2018, we look forward to walking along with the Wish Community to create more life-changing wishes for 3-17 year-old children with critical illnesses, and enrich their human experience with hope, strength and joy.
            </div>
          </div> -->



        <div class="col yellow-col" ref="cdp-section">
          <div class="row abt-cdp-row">
            <div class="abt-cdp">
              <span v-if="SC.U === ENG">About Clé de Peau Beauté</span>
              <span v-if="SC.U === CHI">關於Clé de Peau Beauté</span>
            </div>
          </div>

          <div class="row abt-cdp-desc-row">
            <div class="abt-cdp-desc">
              <span v-if="SC.U === ENG">
                The Key to unlocking a new world of beauty.
                <br />
                <br />
                Launched in 1982, Clé de Peau Beauté combines cutting-edge Japanese science and aesthetic sense with modern French elegance.
                <br />
                <br />
                Clé de Peau Beauté, French for “the key to skin’s beauty” is committed to unlocking every woman’s potential for limitless radiance.This beauty is not just skin deep. It comes from the radiance within. <span class="break767"><br/></span> Clé de Peau Beauté sparks that radiance illuminating beauty that is uniquely yours.
                <br />
                <br />
                For women seeking their fullest beauty, <span class="break375"><br /></span> Clé de Peau Beauté provides an exquisite experience - and holds the key.
              </span>
              <span v-if="SC.U === CHI">
                Clé de Peau Beauté於1982年面世，薈萃日本最尖端的科學和審美觀與法國的高雅氣質。
                <br />
                <br />
                Clé de Peau Beauté是法語「肌膚之鑰」的意思，向女士呈獻美麗之鑰，進入全新的美麗領域，創造前所未見的完美凝肌。<span class="break375"><br/><br/></span>在Clé de Peau Beauté的世界，每位女性也有無限的美麗潛能，我們矢志發掘這份深藏麗質的奧秘。我們追求的美麗不限於肌膚表面，而是源自內在的迷人魅力。Clé de Peau Beauté為您開啟沉睡的閃耀力量，讓您綻發獨特的風采。
              </span>

            </div>
          </div>

          <div class="cta-row" @click="goLearnMore">
            <img class="cta-frame default" src="./img/learn-more-frame.svg" />
            <img class="cta-frame show-1440px" src="./img/learn-more-frame-1440.svg" />

            <div class="cta">
              <span v-if="SC.U === ENG">
                Learn More
              </span>
              <span v-if="SC.U === CHI">
                了解更多
              </span>
            </div>
          </div>

        </div>

        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false; checkScroll() }" @lang="() => { Text.toggle() }" />
    <FullVideo class="full-video" v-show="fullVideo" @close="() => { fullVideo = false; }" :embed="youtubeLink" />
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

import FullVideo from '@/components/Pages/Landing/VideoPopUp.vue'

// import Instruction from './Instruction.vue'

export default {
  components: {
    FloatMenu,
    FullMenu,
    FullVideo
    // Instruction
  },
  data () {
    return {
      youtubeLink: false,
      fullVideo: false,
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {}
    }
  },
  mounted () {
    this.checkScroll()

    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()
    })
  },
  methods: {
    checkScroll () {
      if (window.location.hash === '#radianceis') {
        this.$refs['scroller'].scrollTop = this.$refs['radianceis-section'].offsetTop - 67
      }
      if (window.location.hash === '#cdp') {
        this.$refs['scroller'].scrollTop = this.$refs['cdp-section'].offsetTop - 67
      }
    },
    goLearnMore () {
      var href = document.createElement('a')
      href.target = '_blank'
      if (this.SC.U === this.CHI) {
        href.href = 'http://www.cledepeau-beaute.com/hk/'
      } else {
        href.href = 'http://www.cledepeau-beaute.com/int/'
      }
      href.click()
    },
    goVideo () {
      if (window.innerWidth < 768) {
        var href = document.createElement('a')
        href.target = '_blank'
        href.href = 'https://youtu.be/P7_OmbOMvsY'
        // href.href = 'https://www.dropbox.com/s/b8tyl288hixgs9u/CPBxMAW_Mickco.mp4?dl=0'
        // href.href = require('./video/Mickco.mp4')
        href.click()
      } else {
        this.youtubeLink = 'https://www.youtube.com/embed/P7_OmbOMvsY?rel=0'
        this.fullVideo = true
      }
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.template-layout{
  color: white;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}

.full-video{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 120px;
}
.taller{
  height: 75vh;
}

.bottom-taller{
  height: 0px;
}

.hero-row{
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.hero{
  cursor: pointer;
  border: #CEBC9E solid 3px;
  width: 308px;
  height: 190px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hero img.hero-img {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 308px;
  height: 190px;
}
.hero-overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 308px;
  height: 190px;
  /* Rectangle 11: */
  background: rgba(0,0,0,0.20);
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .hero{
    width: 600px;
    height: 375px;
  }
  .hero img.hero-img{
    width: 600px;
    height: 375px;
  }
  .hero-overlay{
    width: 600px;
    height: 375px;
  }
}
.hero img.hero-play{
  position: absolute;
  top: calc(50% - 30px / 2);
  left: calc(50% - 30px / 2);
}
.col{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}
.row{
  display: flex;
  justify-content: center;
}

.about-radiance-is{
  text-transform: uppercase;
  margin-top: 15px;

  /* ABOUT Radiance Is: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

.about-radiance-is-desc-row{
  margin-top: 15px;
}
.about-radiance-is-desc{
  width: 280px;
  /* For 20 years, with t: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
}
@media screen and (min-width: 374px) {
  .about-radiance-is-desc{
    width: 308px;
  }
}


@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .about-radiance-is-desc{
    width: 600px;
  }
}


.line-row{
  margin-top: 15px;
  padding: 15px 0px;
}
.line{
  background-color: #CEBC9E;
  height: 1px;
  width: 100%;
}
@media screen and (min-width: 374px) {
  .line{
    width: 100%;
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .line-row{
    margin-top: 35px;
  }
  .line{
    width: 600px;
  }
}



.abt-maw-row{
  margin-top: 15px;
}
.abt-maw{
  text-transform: uppercase;
  /* ABOUT MAKE-A-WISH: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
  width: 280px;
}
@media screen and (min-width: 374px) {
  .abt-maw{
    width: 308px;
  }
}


.abt-maw-desc-row{
  margin-top: 15px;
}
.abt-maw-desc{
  /* Make-A-Wish Hong Kon: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
  width: 280px;
}
@media screen and (min-width: 374px) {
  .abt-maw-desc{
    width: 308px;
  }
}

/*-------*/
.yellow-col{
  /* margin-top: 30px; */
  /* Rectangle 23: */
  /* background-image: linear-gradient(-180deg, #FBF8F1 0%, #A88F6C 100%); */
}
.abt-cdp-row{
  margin-top: 20px;
}
.abt-cdp{
  text-transform: uppercase;
  /* ABOUT MAKE-A-WISH: */
  /* border: 1px solid #CEBC9E; */
  /* font-family: CronosPro-LtDisp, PingFangTC-Light; */
  /* Clé de Peau Beauté: */
  /* border: 1px solid #333333; */
  /* font-size: 14px;
  color: #07002A;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px; */

  width: 280px;

  /* ABOUT Clé de Peau Be: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 16px;
  color: #CEBC9E;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}
@media screen and (min-width: 374px) {
  .abt-cdp{
    width: 308px;
  }
}


@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .abt-cdp{
    width: 600px;
  }
}



.abt-cdp-desc-row{
  margin-top: 15px;
}
.abt-cdp-desc{
  /* The Key to unlocking: */
  /* border: 0 solid #333333; */
  /* font-family: CronosPro-LtDisp;
  font-size: 14px;
  color: #333333;
  letter-spacing: 1px;
  line-height: 20px;
  width: 280px; */

  width: 280px;
  /* The Key to unlocking: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFangTC-Light;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  line-height: 20px;
}
@media screen and (min-width: 374px) {
  .abt-cdp-desc{
    width: 308px;
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .abt-cdp-desc{
    width: 600px;
  }
}




.cta-row{
  cursor: pointer;
  margin-top: 15px;
  margin-bottom: 15px;
  position: relative;
  display: flex;
  justify-content: center;
  height: calc(71px);
  transform: scale(0.95);
}
.cta-frame{
  position: absolute;
  top: 0;
  left: calc(50% - 314px / 2);
}
.cta{
  text-transform: uppercase;
  width: 308px;
  height: calc(71px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* Our store: */
  border: 0 solid #FFFFFF;
  font-family: CronosPro-LtDisp, PingFangTC-Light;;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

.show-1440px{
  display: none;
}
@media screen and (min-width: 374px) {
  .cta-row {
    transform: scale(1);
  }
}


@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .cta-frame {
    left: calc(50% - 418px / 2);
  }
  .default{
    display: none;
  }
  .show-1440px{
    display: block;
  }
  .hero img.hero-play{
    top: calc(50% - 50px / 2);
    left: calc(50% - 50px / 2);
    width: 50px;
    height: 50px;
  }
  .row.about-radiance-is{
    margin-top: 45px;
    font-size: 22px;
  }
  .row.about-radiance-is-desc-row{
    margin-top: 20px;
    line-height: 21px;
  }
  /*
  paragraph
  margin-top: 20px;
  */
  .abt-cdp{
    margin-top: 30px;
    font-size: 22px;
  }
  .abt-cdp-desc-row{
    margin-top: 20px;
  }
  .abt-cdp-desc{
    line-height: 21px;
  }
  .cta-row{
    margin-top: 35px;
    margin-bottom: 35px;
  }
  /*
  paragraph
  lineheight 21

  */
}

.break375{
  display: none;
}
@media screen and (width: 375px) {
  .break375{
    display: inline;
  }
}

.break767{
  display: none;
}
@media screen and (min-width: 767px) {
  .break767{
    display: inline;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/About/About.vue